/**
 * Generado automáticamente por scripts/sync-version.cjs.
 * NO editar a mano — se reescribe en cada `npm start` / `npm run build`.
 */
export const APP_VERSION = '1.27.1';
